import { configureStore } from "@reduxjs/toolkit";
import customer from "./slices/customer/customer.slice.ts";
import loan from "./slices/loan/loan.slice.ts";
import layout from "./slices/layout/layout.slice.ts";
import session from "./slices/session/session.slice.ts";
import { useDispatch } from "react-redux";
import { interceptStateForDev } from "./dev-utils.ts";
import { diffLogger } from "../utilities/store-diff-logger.ts";
import { listenerMiddleware } from "../utilities/session-state-change-listener.ts";

const store = configureStore({
  reducer: {
    customer,
    loan,
    layout,
    session,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(diffLogger)
      .prepend(listenerMiddleware.middleware),
});

interceptStateForDev(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;

export type ThunkApi = { state: RootState };

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
// export const useAppSelector = useSelector.withTypes<RootState>();

export default store;
